module.exports = __webpack_public_path__ + "img/banner11.7ec450b4.png";